
/**
 * --- External Imports ---
 */
import { Box, styled } from "@mui/material";
import { Field, Input } from "@ngt/forms-core";
import { FC, Fragment } from "react";

/**
 * --- Internal Imports ---
 */
import { CheckboxFormField } from "../../../../api/dtos/dtos";
import InputCheckboxField from "../InputCheckboxField";
import CheckboxControlLabel from "../labels/CheckboxControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FormFieldComponent from "./FormFieldComponent";
import useFormFieldCondition from "../../../../hooks/validation/useFormFieldCondition";

const FieldSpacer = styled(Box) (() => ({
    position: 'relative',
    height: '5px'
}));

/**
 * --- Checkbox Component ---
 */
const FormFieldCheckbox: FC<IFormFieldComponentProps<CheckboxFormField>> = ({
    field,
    form
}) => {
    
    //
    // -- Hooks
    const { getFormFieldDisplayConditions } = useFormFieldCondition();

    const recordOfFieldConditions = getFormFieldDisplayConditions(field.children);
    
    return (
        <Fragment>
            <CheckboxControlLabel 
                field={field}
                control={
                    <Field propertyPath={`${form.name}.${field.name}`}>
                        <Input 
                            component={InputCheckboxField}
                        />
                    </Field>
                }
            />
            {
                <Box ml='34px'>
                    {
                        field.children?.filter(child => child !== undefined)
                        ?.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                        ?.map((child) => {
                            return (
                                <Fragment key={`fragment-${child.id}-${child.fieldType}`}>
                                    <FormFieldComponent
                                        key={`${child.id}-${child.fieldType}`} 
                                        field={child} 
                                        form={form} 
                                        conditionFn={recordOfFieldConditions?.[`${child.id}-${child.fieldType}`]}
                                    />
                                    <FieldSpacer />
                                </Fragment>
                            )
                        })
                    }
                </Box>
            }
        </Fragment>
    );
}

export default FormFieldCheckbox;